import { number, oneOfType, shape, string } from 'prop-types';

export default shape({
  id: number,
  address: string,
  city: string,
  country_code: string,
  created_at: string,
  facebook_page_id: string,
  industry: oneOfType([
    string,
    shape({
      id: number,
      code: string,
      sector: string,
      subsector: string,
    }),
  ]),
  industry_id: number,
  last_modified: string,
  linked_in_page_id: string,
  logo_large_url: string,
  logo_thumb_url: string,
  avatar_large_url: string,
  avatar_small_url: string,
  name: string,
  postal_code: string,
  primary_color: string,
  secondary_color: string,
  state: string,
});
